"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerProfileEntity = void 0;
const cuid_1 = __importDefault(require("cuid"));
const moment_1 = __importDefault(require("moment"));
const BadRequestError_1 = require("../GS/BadRequestError");
const CustomerProfileDto_1 = require("./CustomerProfileDto");
const CustomerVehicleDto_1 = require("../customer-vehicles/CustomerVehicleDto");
const CustomerVehicleEntity_1 = require("../customer-vehicles/CustomerVehicleEntity");
const stringUtilities_1 = require("../GS/stringUtilities");
const validators_1 = require("../GS/validators");
const LocationDto_1 = require("../locations/LocationDto");
const LocationEntity_1 = require("../locations/LocationEntity");
const LoginDto_1 = require("../logins/LoginDto");
const LoginEntity_1 = require("../logins/LoginEntity");
const Operator_1 = require("../GS/Operator");
const SingleEntityBase_1 = require("../GS/SingleEntityBase");
const ValidationError_1 = require("../GS/ValidationError");
const INDEX_NOT_FOUND = -1;
const MYSQL_TEXT_MAX_LENGTH = 65535;
class CustomerProfileEntity extends SingleEntityBase_1.SingleEntityBase {
    constructor(dependencies, customerProfile) {
        super();
        this._requiredFieldsSetStatus = {
            locationId: false,
            firstName: false,
            lastName: false,
            email: false,
            phone: false,
            contactPreference: false
        };
        this._dependencies = dependencies;
        if (customerProfile === undefined) {
            this._dto = new CustomerProfileDto_1.CustomerProfileDto();
        }
        else if (customerProfile instanceof CustomerProfileDto_1.CustomerProfileDto) {
            this._dto = new CustomerProfileDto_1.CustomerProfileDto(customerProfile);
            this._clearAllRequiredFieldsSetStatuses();
            this._setIsNew(!this._dto.id);
        }
        else if (customerProfile instanceof CustomerProfileEntity) {
            this._dto = new CustomerProfileDto_1.CustomerProfileDto(customerProfile._dto);
            this._clearAllRequiredFieldsSetStatuses();
            this._setIsNew(!this._dto.id);
        }
        else {
            throw new Error("Invalid arg");
        }
    }
    toDto() {
        return new CustomerProfileDto_1.CustomerProfileDto(this._dto);
    }
    getId() {
        return this._dto.id;
    }
    getLocation() {
        if (this._dto.locationId === undefined) {
            return undefined;
        }
        if (this._dto.location === undefined) {
            throw new Error("Cannot call getLocation without first loading the Location.");
        }
        if (!this._locationEntity && this._dto.location) {
            this._locationEntity = new LocationEntity_1.LocationEntity(this._dependencies, this._dto.location);
        }
        return this._locationEntity;
    }
    setLocation(untrustedValue) {
        let untrustedId;
        if (untrustedValue instanceof LocationEntity_1.LocationEntity) {
            if (untrustedValue.isNew) {
                throw new BadRequestError_1.BadRequestError("untrustedValue.isNew cannot be true.");
            }
            untrustedId = untrustedValue.getId();
        }
        else if (untrustedValue instanceof LocationDto_1.LocationDto) {
            untrustedId = untrustedValue.id;
        }
        else {
            throw new BadRequestError_1.BadRequestError("untrustedValue is of an invalid type.");
        }
        this.setLocationId(untrustedId);
        if (this.hasError("locationId")) {
            return;
        }
        if (untrustedValue instanceof LocationEntity_1.LocationEntity) {
            this._locationEntity = untrustedValue;
        }
    }
    getLocationId() {
        return this._dto.locationId;
    }
    setLocationId(untrustedValue) {
        let _untrustedValue;
        this.clearError("locationId");
        this._requiredFieldsSetStatus.locationId = true;
        if (untrustedValue !== undefined &&
            untrustedValue !== null &&
            !validators_1.isInt(untrustedValue, { min: 1 })) {
            this.addError(new ValidationError_1.ValidationError("locationId", "Location Id is invalid."));
        }
        if (typeof untrustedValue === "string") {
            _untrustedValue = parseInt(untrustedValue, 10);
        }
        else {
            _untrustedValue = untrustedValue;
        }
        if (_untrustedValue === undefined || _untrustedValue === null) {
            this.addError(new ValidationError_1.ValidationError("locationId", "Location is required."));
        }
        if (!this.isNew && _untrustedValue === this._dto.locationId) {
            return;
        }
        this._dto.locationId = _untrustedValue;
        delete this._locationEntity;
        this._setIsDirty(true);
    }
    getLogin() {
        if (this._dto.loginId === undefined) {
            return undefined;
        }
        if (this._dto.login === undefined) {
            throw new Error("Cannot call getLogin without first loading the Login.");
        }
        if (!this._loginEntity && this._dto.login) {
            this._loginEntity = new LoginEntity_1.LoginEntity(this._dependencies, this._dto.login);
        }
        return this._loginEntity;
    }
    setLogin(untrustedValue) {
        let untrustedId;
        if (untrustedValue instanceof LoginEntity_1.LoginEntity) {
            if (untrustedValue.isNew) {
                throw new BadRequestError_1.BadRequestError("untrustedValue.isNew cannot be true.");
            }
            untrustedId = untrustedValue.getId();
        }
        else if (untrustedValue instanceof LoginDto_1.LoginDto) {
            untrustedId = untrustedValue.id;
        }
        else {
            throw new BadRequestError_1.BadRequestError("untrustedValue is of an invalid type.");
        }
        this.setLoginId(untrustedId);
        if (this.hasError("loginId")) {
            return;
        }
        if (untrustedValue instanceof LoginEntity_1.LoginEntity) {
            this._loginEntity = untrustedValue;
        }
    }
    getLoginId() {
        return this._dto.loginId;
    }
    setLoginId(untrustedValue) {
        let _untrustedValue;
        this.clearError("loginId");
        if (untrustedValue !== undefined &&
            untrustedValue !== null &&
            !validators_1.isInt(untrustedValue, { min: 1 })) {
            this.addError(new ValidationError_1.ValidationError("loginId", "Login Id is invalid."));
        }
        if (typeof untrustedValue === "string") {
            _untrustedValue = parseInt(untrustedValue, 10);
        }
        else {
            _untrustedValue = untrustedValue;
        }
        if (!this.isNew && _untrustedValue === this._dto.loginId) {
            return;
        }
        this._dto.loginId = _untrustedValue;
        delete this._loginEntity;
        this._setIsDirty(true);
    }
    getFirstName() {
        return this._dto.firstName;
    }
    setFirstName(untrustedValue) {
        const maxLength = 255;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("firstName");
        this._requiredFieldsSetStatus.firstName = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("firstName", "First Name is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("firstName", `First Name has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.firstName) {
            return;
        }
        this._dto.firstName = _untrustedValue;
        this._setIsDirty(true);
    }
    getLastName() {
        return this._dto.lastName;
    }
    setLastName(untrustedValue) {
        const maxLength = 255;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("lastName");
        this._requiredFieldsSetStatus.lastName = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("lastName", "Last Name is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("lastName", `Last Name has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.lastName) {
            return;
        }
        this._dto.lastName = _untrustedValue;
        this._setIsDirty(true);
    }
    getEmail() {
        return this._dto.email;
    }
    setEmail(untrustedValue) {
        const maxLength = 255;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("email");
        if (_untrustedValue.length > 0) {
            this._requiredFieldsSetStatus.phone = true;
            this._requiredFieldsSetStatus.email = true;
        }
        if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("email", `Email has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.email) {
            return;
        }
        this._dto.email = _untrustedValue;
        this._setIsDirty(true);
    }
    getPhoneCountryCode() {
        return this._dto.phoneCountryCode;
    }
    setPhoneCountryCode(untrustedValue) {
        const maxLength = 255;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("phoneCountryCode");
        if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("phoneCountryCode", `Phone Country Code has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.phoneCountryCode) {
            return;
        }
        this._dto.phoneCountryCode = _untrustedValue;
        this._setIsDirty(true);
    }
    getPhone() {
        return this._dto.phone;
    }
    setPhone(untrustedValue) {
        const maxLength = 20;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("phone");
        if (_untrustedValue.length > 0) {
            this._requiredFieldsSetStatus.phone = true;
            this._requiredFieldsSetStatus.email = true;
        }
        if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("phone", `Phone has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.phone) {
            return;
        }
        this._dto.phone = _untrustedValue;
        this._setIsDirty(true);
    }
    getZipCode() {
        return this._dto.zipCode;
    }
    setZipCode(untrustedValue) {
        const maxLength = 10;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("zipCode");
        if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("zipCode", `Zip Code has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.zipCode) {
            return;
        }
        this._dto.zipCode = _untrustedValue;
        this._setIsDirty(true);
    }
    getContactPreference() {
        return this._dto.contactPreference;
    }
    setContactPreference(untrustedValue) {
        const maxLength = 11;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("contactPreference");
        this._requiredFieldsSetStatus.contactPreference = true;
        if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("contactPreference", `Contact Preference has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.contactPreference) {
            return;
        }
        this._dto.contactPreference = _untrustedValue;
        this._setIsDirty(true);
    }
    getRewardsNumber() {
        return this._dto.rewardsNumber;
    }
    setRewardsNumber(untrustedValue) {
        const maxLength = 255;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("rewardsNumber");
        if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("rewardsNumber", `Rewards Number has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.rewardsNumber) {
            return;
        }
        this._dto.rewardsNumber = _untrustedValue;
        this._setIsDirty(true);
    }
    getIsLoyaltyRewardsUser() {
        return this._dto.isLoyaltyRewardsUser;
    }
    setIsLoyaltyRewardsUser(untrustedValue) {
        let _untrustedValue;
        if (typeof untrustedValue === "number") {
            if (untrustedValue !== 0 && untrustedValue !== 1) {
                this.addError(new ValidationError_1.ValidationError("isLoyaltyRewardsUser", "Is Loyalty Rewards User is invalid."));
            }
            _untrustedValue = untrustedValue === 1;
        }
        else if (typeof untrustedValue === "string") {
            untrustedValue = untrustedValue.trim().toLowerCase();
            if (["0", "1", "false", "true"].indexOf(untrustedValue) === INDEX_NOT_FOUND) {
                this.addError(new ValidationError_1.ValidationError("isLoyaltyRewardsUser", "Is Loyalty Rewards User is invalid."));
            }
            _untrustedValue = [
                "1", "true"
            ].indexOf(untrustedValue) !== INDEX_NOT_FOUND;
        }
        else if (typeof untrustedValue === "boolean") {
            _untrustedValue = untrustedValue;
        }
        else {
            throw new Error("Invalid type");
        }
        if (!this.isNew && _untrustedValue === this._dto.isLoyaltyRewardsUser) {
            return;
        }
        this.clearError("isLoyaltyRewardsUser");
        this._dto.isLoyaltyRewardsUser = _untrustedValue;
        this._setIsDirty(true);
    }
    getAuthenticationCode() {
        return this._dto.authenticationCode;
    }
    generateAuthenticationCode() {
        this._dto.authenticationCode = stringUtilities_1.generateRandomString(6, "0123456789");
        this._dto.authenticationCodeExpiresAt = moment_1.default().add(1, "hour")
            .toISOString();
        this._setIsDirty(true);
    }
    getAuthenticationCodeExpiresAt() {
        return this._dto.authenticationCodeExpiresAt;
    }
    getAuthorizationToken() {
        return this._dto.authorizationToken;
    }
    generateAuthorizationToken() {
        if (!this._dto.authenticationCode ||
            !this._dto.authenticationCodeExpiresAt ||
            moment_1.default().isSameOrAfter(this._dto.authenticationCodeExpiresAt)) {
            this.addError(new ValidationError_1.ValidationError("authorizationToken", "Authorization Code has expired."));
        }
        this._dto.authorizationToken = cuid_1.default();
        this._dto.authenticationCode = "";
        this._dto.authenticationCodeExpiresAt = "";
        this._setIsDirty(true);
    }
    clearAuthenticationCodeInfo() {
        if (!this._dto.authenticationCode ||
            !this._dto.authenticationCodeExpiresAt ||
            moment_1.default().isSameOrAfter(this._dto.authenticationCodeExpiresAt)) {
            this.addError(new ValidationError_1.ValidationError("authenticationCode", "Authentication Code has expired."));
        }
        this._dto.authenticationCode = "";
        this._dto.authenticationCodeExpiresAt = "";
        this._setIsDirty(true);
    }
    getPhoneHasBeenVerified() {
        return this._dto.phoneHasBeenVerified;
    }
    setPhoneHasBeenVerified(untrustedValue) {
        let _untrustedValue;
        if (typeof untrustedValue === "number") {
            if (untrustedValue !== 0 && untrustedValue !== 1) {
                this.addError(new ValidationError_1.ValidationError("phoneHasBeenVerified", "Phone Has Been Verified is invalid."));
            }
            _untrustedValue = untrustedValue === 1;
        }
        else if (typeof untrustedValue === "string") {
            untrustedValue = untrustedValue.trim().toLowerCase();
            if (["0", "1", "false", "true"].indexOf(untrustedValue) === INDEX_NOT_FOUND) {
                this.addError(new ValidationError_1.ValidationError("phoneHasBeenVerified", "Phone Has Been Verified is invalid."));
            }
            _untrustedValue = [
                "1", "true"
            ].indexOf(untrustedValue) !== INDEX_NOT_FOUND;
        }
        else if (typeof untrustedValue === "boolean") {
            _untrustedValue = untrustedValue;
        }
        else {
            throw new Error("Invalid type");
        }
        if (!this.isNew && _untrustedValue === this._dto.phoneHasBeenVerified) {
            return;
        }
        this.clearError("phoneHasBeenVerified");
        this._dto.phoneHasBeenVerified = _untrustedValue;
        this._setIsDirty(true);
    }
    getEmailHasBeenVerified() {
        return this._dto.emailHasBeenVerified;
    }
    setEmailHasBeenVerified(untrustedValue) {
        let _untrustedValue;
        if (typeof untrustedValue === "number") {
            if (untrustedValue !== 0 && untrustedValue !== 1) {
                this.addError(new ValidationError_1.ValidationError("emailHasBeenVerified", "Email Has Been Verified is invalid."));
            }
            _untrustedValue = untrustedValue === 1;
        }
        else if (typeof untrustedValue === "string") {
            untrustedValue = untrustedValue.trim().toLowerCase();
            if (["0", "1", "false", "true"].indexOf(untrustedValue) === INDEX_NOT_FOUND) {
                this.addError(new ValidationError_1.ValidationError("emailHasBeenVerified", "Email Has Been Verified is invalid."));
            }
            _untrustedValue = [
                "1", "true"
            ].indexOf(untrustedValue) !== INDEX_NOT_FOUND;
        }
        else if (typeof untrustedValue === "boolean") {
            _untrustedValue = untrustedValue;
        }
        else {
            throw new Error("Invalid type");
        }
        if (!this.isNew && _untrustedValue === this._dto.emailHasBeenVerified) {
            return;
        }
        this.clearError("emailHasBeenVerified");
        this._dto.emailHasBeenVerified = _untrustedValue;
        this._setIsDirty(true);
    }
    getCustomData() {
        return this._dto.customData;
    }
    setCustomData(untrustedValue) {
        const maxLength = MYSQL_TEXT_MAX_LENGTH;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("customData");
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("customData", "Custom Data is required."));
        }
        else {
            if (_untrustedValue.length > maxLength) {
                this.addError(new ValidationError_1.ValidationError("customData", `Custom Data has exceeded the maximum length (${maxLength} chr).`));
            }
        }
        if (!this.isNew && _untrustedValue === this._dto.customData) {
            return;
        }
        this._dto.customData = _untrustedValue;
        this._setIsDirty(true);
    }
    setIsDealervault(val) {
        this._dto.isDealervault = val;
    }
    getIsDealervault() {
        return this._dto.isDealervault;
    }
    setIsOpentrack(val) {
        this._dto.isOpentrack = val;
    }
    getIsOpentrack() {
        return this._dto.isOpentrack;
    }
    getIsDeleted() {
        return this._dto.isDeleted;
    }
    setIsDeleted(untrustedValue) {
        let _untrustedValue;
        if (typeof untrustedValue === "number") {
            if (untrustedValue !== 0 && untrustedValue !== 1) {
                this.addError(new ValidationError_1.ValidationError("isDeleted", "Is Deleted is invalid."));
            }
            _untrustedValue = untrustedValue === 1;
        }
        else if (typeof untrustedValue === "string") {
            untrustedValue = untrustedValue.trim().toLowerCase();
            if (["0", "1", "false", "true"].indexOf(untrustedValue) === INDEX_NOT_FOUND) {
                this.addError(new ValidationError_1.ValidationError("isDeleted", "Is Deleted is invalid."));
            }
            _untrustedValue = [
                "1", "true"
            ].indexOf(untrustedValue) !== INDEX_NOT_FOUND;
        }
        else if (typeof untrustedValue === "boolean") {
            _untrustedValue = untrustedValue;
        }
        else {
            throw new Error("Invalid type");
        }
        this.clearError("isDeleted");
        if (!this.isNew && _untrustedValue === this._dto.isDeleted) {
            return;
        }
        this._dto.isDeleted = _untrustedValue;
        delete this._dto.deletedAt;
        this._setIsDirty(true);
    }
    getDeletedAt() {
        return this._dto.deletedAt;
    }
    getCreatedAt() {
        return this._dto.createdAt;
    }
    getUpdatedAt() {
        return this._dto.updatedAt;
    }
    getCustomerVehicles() {
        var _a;
        if (this.isNew) {
            return undefined;
        }
        if (this._dto.customerVehicles === undefined) {
            throw new Error("Cannot call getCustomerVehicles without " +
                "first loading the customerVehicles.");
        }
        if (!this._customerVehicleEntities && this._dto.customerVehicles) {
            this._customerVehicleEntities = (_a = this._dto.customerVehicles) === null || _a === void 0 ? void 0 : _a.map((customerVehicleDto) => new CustomerVehicleEntity_1.CustomerVehicleEntity(this._dependencies, customerVehicleDto));
        }
        return this._customerVehicleEntities;
    }
    setCustomerVehicles(customerVehicles) {
        this._dto.customerVehicles = customerVehicles.map((customerVehicle) => {
            if (customerVehicle instanceof CustomerVehicleEntity_1.CustomerVehicleEntity) {
                return new CustomerVehicleDto_1.CustomerVehicleDto(customerVehicle.toDto());
            }
            return new CustomerVehicleDto_1.CustomerVehicleDto(customerVehicle);
        });
        delete this._customerVehicleEntities;
        this._setIsDirty(true);
    }
    addCustomerVehicle(customerVehicle) {
        if (this._dto.customerVehicles === undefined) {
            throw new Error("Cannot call addCustomerVehicle without " +
                "first loading the customerVehicles.");
        }
        if (!this._dto.customerVehicles) {
            this._dto.customerVehicles = [];
        }
        this._dto.customerVehicles.push(customerVehicle.toDto());
        if (this._customerVehicleEntities) {
            this._customerVehicleEntities.push(new CustomerVehicleEntity_1.CustomerVehicleEntity(this._dependencies, customerVehicle));
        }
        this._setIsDirty(true);
    }
    removeCustomerVehicle(customerVehicle) {
        let customerVehicleId;
        if (customerVehicle instanceof CustomerVehicleEntity_1.CustomerVehicleEntity) {
            customerVehicleId = customerVehicle.getId();
        }
        else if (customerVehicle instanceof CustomerVehicleDto_1.CustomerVehicleDto) {
            customerVehicleId = customerVehicle.id;
        }
        else if (typeof customerVehicle === "string") {
            customerVehicleId = parseInt(customerVehicle, 10);
        }
        else {
            customerVehicleId = customerVehicle;
        }
        if (this._dto.customerVehicles) {
            this._dto.customerVehicles = this._dto.customerVehicles.filter((customerVehicleDto) => (customerVehicleDto.id !== customerVehicleId));
        }
        if (this._customerVehicleEntities) {
            this._customerVehicleEntities = this._customerVehicleEntities.filter((_customerVehicle) => (_customerVehicle.getId() !== customerVehicleId));
        }
        this._setIsDirty(true);
    }
    loadCustomerVehiclesAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                this._emit("before-loadCustomerVehiclesAsync");
                this._dto.customerVehicles = (yield this._dependencies.customerVehicleDatastore.findAsync({
                    selector: {
                        "customerProfile.id": { [Operator_1.Operator.EQUALS_TO]: this.getId() }
                    },
                    sort: [{ year: "desc" }, { make: "asc" }, { model: "asc" }]
                })).dtos;
                delete this._customerVehicleEntities;
                this._emit("after-loadCustomerVehiclesAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    loadLocationAsync(expand) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                if (!this.getLocationId()) {
                    return;
                }
                this._emit("before-loadLocationAsync");
                this._dto.location = yield this._dependencies.locationDatastore
                    .getAsync(this.getLocationId(), expand);
                delete this._locationEntity;
                this._emit("after-loadLocationAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    loadLoginAsync(expand) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                if (!this.getLoginId()) {
                    return;
                }
                this._emit("before-loadLoginAsync");
                this._dto.login = yield this._dependencies.loginDatastore
                    .getAsync(this.getLoginId(), expand);
                delete this._loginEntity;
                this._emit("after-loadLoginAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    loadAsync(id, expand) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (typeof id === "string") {
                    if (!validators_1.isInt(id, { min: 1 })) {
                        throw new BadRequestError_1.BadRequestError("ID is not valid.");
                    }
                    id = parseInt(id, 10);
                }
                this._setState("busy");
                this._emit("before-loadAsync");
                this._dto = yield this._dependencies.customerProfileDatastore
                    .getAsync(id, expand);
                delete this._locationEntity;
                delete this._loginEntity;
                delete this._customerVehicleEntities;
                this._setIsNew(false);
                this._setIsDirty(false);
                this._clearAllRequiredFieldsSetStatuses();
                this.clearErrors();
                this._emit("after-loadAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    saveAsync() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                this._emit("before-saveAsync");
                if (!this._requiredFieldsSetStatus.phone &&
                    !this._requiredFieldsSetStatus.email) {
                    this.addError(new ValidationError_1.ValidationError("phone", "Phone or Email is required."));
                    this.addError(new ValidationError_1.ValidationError("email", "Phone or Email is required."));
                }
                if (!this.allRequiredFieldsSet) {
                    const fields = Object.entries(this._requiredFieldsSetStatus)
                        .filter(([, isSet]) => !isSet).map(([field]) => field);
                    throw new Error(`The following required fields were never set: ${fields.join(", ")}`);
                }
                if (!this.canSave) {
                    throw new Error("Customer Profile is not in a valid state.");
                }
                let dto = this.toDto();
                if (dto.customerVehicles) {
                    dto.customerVehicles = (_a = dto.customerVehicles) === null || _a === void 0 ? void 0 : _a.map((customerVehicle) => ({ id: customerVehicle.id }));
                }
                if (this.isNew) {
                    dto = yield this._dependencies.customerProfileDatastore
                        .addAsync(this._dto);
                }
                else if (this.isDirty) {
                    dto = yield this._dependencies.customerProfileDatastore
                        .updateAsync(this._dto);
                }
                this._dto.id = dto.id;
                this._dto.deletedAt = dto.deletedAt;
                this._dto.createdAt = dto.createdAt;
                this._dto.updatedAt = dto.updatedAt;
                this._setIsNew(false);
                this._setIsDirty(false);
                this._emit("after-saveAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    deleteAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                this._emit("before-deleteAsync");
                if (!this.canDelete) {
                    throw new Error("Customer Profile cannot be deleted.");
                }
                if (!this.isNew) {
                    yield this._dependencies.customerProfileDatastore
                        .removeAsync(this.getId());
                }
                this._emit("after-deleteAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
}
exports.CustomerProfileEntity = CustomerProfileEntity;
//# sourceMappingURL=CustomerProfileEntity.js.map